export enum TemplateLanguage {
  nl = 0,
  fr = 1,
  de = 2,
}
